import styled from 'styled-components';
import { padding } from '@grnhse/seedling/lib/azalea/constants';

export const AvailabilityContainer = styled.div`
  width: 100%;

  margin-top: ${padding.small};
`;
